import type { SubmissionAction } from '@/classes/SubmissionStatuses/types'
import FixPaymentModalContent from '@/components/home/SubmissionStatuses/ResubmissionModals/FixPaymentModalContent.vue'

export default class UpgradeAction implements SubmissionAction {
	buttonText = 'Upgrade'
	component = FixPaymentModalContent
}
